// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddPayoutFailure-errorMessage-boTMb {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}
.AddPayoutFailure-space1-n81Df {
	margin-bottom: 6px !important;
}
.AddPayoutFailure-space2-Q9vXy {
	margin-bottom: 12px !important;
}
.AddPayoutFailure-space3-RoklX {
	margin-bottom: 18px !important;
}
.AddPayoutFailure-space4-KcPE0 {
	margin-bottom: 24px !important;
}
.AddPayoutFailure-space5-CMipt {
	margin-bottom: 30px !important;
}
.AddPayoutFailure-space6-Ya41c {
	margin-bottom: 36px !important;
}
.AddPayoutFailure-space7-e84ab {
	margin-bottom: 42px !important;
}
.AddPayoutFailure-space8-NgcyQ {
	margin-bottom: 48px !important;
}
.AddPayoutFailure-spaceTop1-RvsW9 {
	margin-top: 6px !important;
}
.AddPayoutFailure-spaceTop2-Y_Zt9 {
	margin-top: 12px !important;
}
.AddPayoutFailure-spaceTop3-NAjXe {
	margin-top: 18px !important;
}
.AddPayoutFailure-spaceTop4-JLFdl {
	margin-top: 24px !important;
}
.AddPayoutFailure-spaceTop5-QFdXG {
	margin-top: 30px !important;
}
.AddPayoutFailure-spaceTop6-y2CWj {
	margin-top: 36px !important;
}
.AddPayoutFailure-spaceTop7-_Zk8i {
	margin-top: 42px !important;
}
.AddPayoutFailure-spaceTop8-erzgE {
	margin-top: 48px !important;
}
.AddPayoutFailure-noMargin-sk_0w {
	margin: 0px !important;
}
.AddPayoutFailure-padding1-rqKVt {
	padding-bottom: 6px !important;
}
.AddPayoutFailure-padding2-uCPVk {
	padding-bottom: 12px !important;
}
.AddPayoutFailure-padding3-gxXM7 {
	padding-bottom: 18px !important;
}
.AddPayoutFailure-padding4-vJXD7 {
	padding-bottom: 24px !important;
}
.AddPayoutFailure-padding5-ad0kO {
	padding-bottom: 30px !important;
}
.AddPayoutFailure-padding6-SRYGZ {
	padding-bottom: 36px !important;
}
.AddPayoutFailure-padding7-GHpAC {
	padding-bottom: 42px !important;
}
.AddPayoutFailure-paddingTop1-C6oeT {
	padding-top: 6px !important;
}
.AddPayoutFailure-paddingTop2-bFwHd {
	padding-top: 12px !important;
}
.AddPayoutFailure-paddingTop3-WeHk7 {
	padding-top: 18px !important;
}
.AddPayoutFailure-paddingTop4-RiV9_ {
	padding-top: 24px !important;
}
.AddPayoutFailure-paddingTop5-htvDS {
	padding-top: 30px !important;
}
.AddPayoutFailure-paddingTop6-B9tUz {
	padding-top: 36px !important;
}
.AddPayoutFailure-paddingTop7-cQo0W {
	padding-top: 42px !important;
}
.AddPayoutFailure-noPadding-R8EgF {
	padding: 0px !important;
}
.AddPayoutFailure-spaceMarginBottom0-BfdTq {
	margin-bottom: 0;
}
.AddPayoutFailure-textBold-RR6hf {
	font-weight: 500 !important;
}
.AddPayoutFailure-textBolder-e3Uuf {
	font-weight: 700 !important;
}
.AddPayoutFailure-textNormal-uuWpt {
	font-weight: normal !important;
}
/*New Design Text Colors */
.AddPayoutFailure-textDarkBlue-tfz9T {
	color: rgb(20, 39, 94) !important;
}
.AddPayoutFailure-textLightBlue-w00Jg {
	color: rgb(57, 87, 106) !important;
}
.AddPayoutFailure-textLightSandleGreen-XQtcA {
	color: rgb(76, 86, 41) !important;
}
.AddPayoutFailure-textLightBrown-nJa8V {
	color: rgb(115, 79, 33) !important;
}
.AddPayoutFailure-textMediumMaroon-zAMkJ {
	color: rgb(87, 37, 51) !important;
}
.AddPayoutFailure-textBrown-sKYhg {
	color: rgb(160, 47, 24) !important;
}
.AddPayoutFailure-textMaroon-EfGk7 {
	color: rgb(155, 49, 67) !important;
}
.AddPayoutFailure-textDarkBrown-YvZC9 {
	color: rgb(83, 18, 16) !important;
}
.AddPayoutFailure-textMediumBrown-Aygy8 {
	color: rgb(142, 28, 10) !important;
}
.AddPayoutFailure-textSkyBlue-rPj98 {
	color: rgb(37, 117, 141) !important;
}
.AddPayoutFailure-textGray-wkXWv {
	color: rgb(77, 65, 51) !important;
}
.AddPayoutFailure-btn-glATD,
.AddPayoutFailure-btn-glATD:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 8px 12px 8px !important;
	width: auto;
	outline: 0 !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 6px !important;
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}
.AddPayoutFailure-btn-glATD:hover {
	background: var(--common-background-color) !important;
	outline: 0 !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.AddPayoutFailure-btn-glATD:hover img {
	-webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);
	        filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);
}
.AddPayoutFailure-btnPrimary-lX8Qi,
.AddPayoutFailure-btnPrimary-lX8Qi:focus {
	border-color: var(--btn-primary-bg) !important;
	background-color: var(--btn-primary-bg) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.AddPayoutFailure-btnPrimary-lX8Qi:hover {
	border-color: var(--btn-primary-bg-hover) !important;
	background-color: var(--btn-primary-bg-hover) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.AddPayoutFailure-btnPrimaryBorder-I_lnL,
.AddPayoutFailure-btnPrimaryBorder-I_lnL:focus {
	border-color: var(--primary-border) !important;
	color: var(--common-text-color) !important;
	background-color: var(--btn-primary-color) !important;
	border-radius: 6px;
	padding: 8px 12px 8px !important;
	font-weight: 500;
	-webkit-box-shadow: inherit !important;
	        box-shadow: inherit !important;
}
.AddPayoutFailure-btnPrimaryBorder-I_lnL:hover {
	border-color: var(--primary-border) !important;
	color: var(--common-text-color) !important;
	background-color: var(--btn-primary-color) !important;
	text-decoration: none !important;
	font-weight: 500;
}
.AddPayoutFailure-btnSecondary-ObVUi,
.AddPayoutFailure-btnSecondary-ObVUi:focus {
	border: 1px solid var(--primary-border) !important;
	background-color: var(--btn-secondary-bg) !important;
	color: var(--white-text) !important;
	padding: 8px 12px 8px !important;
	font-weight: 500;
	white-space: pre-line;
}
.AddPayoutFailure-btnSecondary-ObVUi:hover {
	border: 1px solid var(--primary-border) !important;
	background-color: var(--btn-secondary-hover-bg) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.AddPayoutFailure-btnLink-Ub3IS,
.AddPayoutFailure-btnLink-Ub3IS:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	width: auto !important;
	outline: 0 !important;
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: inherit;
	border: 0px !important;
}
.AddPayoutFailure-btnLink-Ub3IS:hover {
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	outline: 0 !important;
	text-decoration: underline;
	font-weight: 500;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	border: 0px !important;
}
.AddPayoutFailure-btnLinkPrimary-sJdBB,
.AddPayoutFailure-btnLinkPrimary-sJdBB:focus {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}
.AddPayoutFailure-btnLinkPrimary-sJdBB:hover {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}
.AddPayoutFailure-btnLinkSecondary-KgeS5,
.AddPayoutFailure-btnLinkSecondary-KgeS5:focus {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-link-color) !important;
	font-size: 16px;
	font-weight: 500;
	border-bottom: 1px solid var(--common-link-color) !important;
	border-radius: 0 !important;
	padding: 0 !important;
}
.AddPayoutFailure-btnLinkSecondary-KgeS5:hover {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-link-color) !important;
	font-weight: 500;
	text-decoration: none !important;
	border-bottom: 1px solid var(--common-link-color) !important;
}
.AddPayoutFailure-searchFilterPopover-ZmddX {
	position: absolute;
	top: 57px;
	left: 0px;
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	display: inline-block;
	visibility: visible;
	background: var(--primary-white-bg);
	-o-border-image: initial;
	   border-image: initial;
	-webkit-box-shadow: 0px 3px 6px #00000029;
	        box-shadow: 0px 3px 6px #00000029;
	border-radius: 12px;
}
.AddPayoutFailure-searchFilterPopoverFull-Z36Uw {
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 66%;
	height: initial;
	-webkit-box-shadow: none;
	        box-shadow: none;
	visibility: visible;
	top: 148px;
	background: var(--primary-white-bg);
	border-radius: 4px;
	border-width: initial;
	border-style: none;
	border-color: initial;
	-o-border-image: initial;
	   border-image: initial;
}
.AddPayoutFailure-searchFilterPopoverOverlay-Ygd0L {
	position: fixed;
	height: 100vh;
	width: 100%;
	top: 64px;
	z-index: 2;
	background: rgba(255, 255, 255, 0.85);
	left: 0;
	right: 0;
	bottom: 0;
}
.AddPayoutFailure-searchFilterPopoverContent-RuB9M {
	min-width: 370px;
	padding: 26px 26px 16px;
	height: 294px;
}
.AddPayoutFailure-searchFilterCloseIcon-fV_S9 {
	font-size: 30px;
	color: var(--modalText-color);
}
.AddPayoutFailure-searchFilterPopoverFooter-YUHkr {
	width: 100%;
	position: relative;
	line-height: 0;
}
.AddPayoutFailure-displayTable-t4CuL {
	display: table;
	width: 100%;
	vertical-align: middle;
}
.AddPayoutFailure-displayTableRow-uxask {
	display: table-row;
	vertical-align: middle;
}
.AddPayoutFailure-displayTableCell-Sg56E {
	display: table-cell;
	vertical-align: middle;
}
.AddPayoutFailure-displayInlineBlock-xe1Jb {
	display: inline-block;
	vertical-align: top;
	white-space: normal;
}
.AddPayoutFailure-fullWidth-j6jlP {
	width: 100% !important;
}
.AddPayoutFailure-captionTitle-qGe8I {
	font-size: 18px;
}
.AddPayoutFailure-showTabletSection-fvgVg {
	display: none !important;
}
.AddPayoutFailure-incrementDecrementButton-zXk4H {
	width: 100%;
	border: 1px solid var(--primary-border);
	border-radius: 6px;
	display: block;
	overflow: hidden;
	-webkit-appearance: none;
}
.AddPayoutFailure-commonBorder-fAAEm {
	border: 1px solid transparent !important;
	color: var(--modalText-color) !important;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	border-radius: 60px !important;
	box-shadow: 0 1px 15px 3px #eeebeb !important;
	-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;
	-webkit-appearance: none !important;
}
.AddPayoutFailure-textCenter-kjoB8 {
	text-align: center;
}
@media screen and (max-width: 768px) {
	.AddPayoutFailure-searchFilterPopoverFull-Z36Uw {
		width: 100%;
		height: 100%;
		top: 0px;
		-webkit-box-shadow: none;
		        box-shadow: none;
		border: 1px solid var(--primary-white-bg);
		max-height: 100%;
		-webkit-overflow-scrolling: touch;
	}

	.AddPayoutFailure-searchFilterPopoverContent-RuB9M {
		min-width: 320px;
		padding: 15px 15px 70px !important;
		height: 100%;
		min-height: 50vh;
		overflow: hidden;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.AddPayoutFailure-searchFilterPopoverHeader-UGAFB {
		position: fixed;
		top: 0;
		z-index: 7;
		left: 0;
		right: 0;
		width: 100%;
		padding: 10px 15px;
		background: var(--primary-white-bg);
	}

	.AddPayoutFailure-searchFilterPopoverFooter-YUHkr {
		font-weight: 600;
		position: fixed;
		top: 38%;
		left: 0;
		right: 0;
		background-color: transparent;
		z-index: 10;
	}

	.AddPayoutFailure-textSize-p870C {
		font-size: 20px;
		font-weight: 600;
		display: block;
		width: 100% !important;
		height: 45px;
	}
}
.AddPayoutFailure-capitalizeText-inrZP {
	text-transform: capitalize;
}
.AddPayoutFailure-hideBothTabletAndMobile-zaTTK {
	display: inline-block;
}
@media (max-width: 1199px) {
	.AddPayoutFailure-hideBothTabletAndMobile-zaTTK {
		display: none !important;
	}
}
@media screen and (max-width: 350px) {
	.AddPayoutFailure-btnFontsize-W2C7b {
		font-size: 12px !important;
	}
}
@media (max-width: 360px) {
	.AddPayoutFailure-searchFilterCloseIcon-fV_S9 {
		font-size: 25px;
	}
}
.AddPayoutFailure-transmissionBottom-hrgA8 {
	padding-bottom: 21px !important;
}
.AddPayoutFailure-marginTop20-Pkaxt {
	margin-top: 35px;
}
.AddPayoutFailure-marginRight15-EB34w {
	margin-right: 15px !important;
}
.AddPayoutFailure-marginNone-IFmk7 {
	margin: 0 !important;
}
.AddPayoutFailure-paddingNone-fx5M5 {
	padding: 0 !important;
}
.AddPayoutFailure-infoPadding-WUeAi {
	padding-right: 6px;
}
@media(min-width:768px) {
	.AddPayoutFailure-pullRight-tC2na {
		float: right;
	}
}
.AddPayoutFailure-displayFlex-HxcCw {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}
@media(max-width:767px) {

	.AddPayoutFailure-displayFlex-HxcCw {
		-webkit-box-pack: justify;
		    -ms-flex-pack: justify;
		        justify-content: space-between;
	}

	.AddPayoutFailure-hideTabletSection-BrlMP {
		display: none !important;
	}

	.AddPayoutFailure-showTabletSection-fvgVg {
		display: block !important;
	}
}
/*****************Apply Button Alignment Start **********************/
.AddPayoutFailure-applyBtnDesktop-xG3hS {
	text-align: right;
}
.AddPayoutFailure-applyBtn-h4xI3,
.AddPayoutFailure-applyBtn-h4xI3:hover,
.AddPayoutFailure-applyBtn-h4xI3:active,
.AddPayoutFailure-applyBtn-h4xI3:focus {
	background-color: var(--common-background-color) !important;
	color: var(--white-text) !important;
	border-radius: 6px;
	text-decoration: none;
	padding: 9px 15px 10px;
	font-size: 16px;
}
@media screen and (max-width: 991px) {
	.AddPayoutFailure-applyBtnDesktop-xG3hS {
		text-align: center;
	}

	.AddPayoutFailure-applyBtnDesktopRight-Ig3r6 {
		text-align: right !important;
	}

	.AddPayoutFailure-applyBtnDesktopNoPaddingRight-xbjnx {
		padding-right: 0px !important;
	}
}
@media screen and (max-width: 767px) {
	.AddPayoutFailure-searchFilterPopoverFooter-YUHkr {
		position: relative !important;
		top: inherit;
	}
}
/*****************Apply Button Alignment Start **********************/
/*************************** Header Modal Start **********************/
.AddPayoutFailure-activeItem-Gyy0j {
	padding: 15px;
	text-align: center;
	font-size: 16px;
	border-radius: 6px;
	cursor: pointer;
	border: 1px solid var(--primary-border);
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}
.AddPayoutFailure-activeItem-Gyy0j:hover,
.AddPayoutFailure-activeItem-Gyy0j:focus,
.AddPayoutFailure-activeItem-Gyy0j:active {
	background-color: var(--common-background-color);
	color: var(--white-text);
	border-radius: 6px;
}
.AddPayoutFailure-activeSection-SuNqy:first-child {
	background-color: var(--common-background-color);
	color: var(--white-text);
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}
.AddPayoutFailure-currencyAndLangGrid-C5Ybi {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 12px;
}
@media (max-width:767px) {
	.AddPayoutFailure-currencyAndLangGrid-C5Ybi {
		grid-template-columns: repeat(2, 1fr);
	}
}
/*************************** Header Modal End **********************/
.AddPayoutFailure-root-XnqK7 {
	padding-left: 20px;
	padding-right: 20px;
}
.AddPayoutFailure-container-JWSVr {
	margin: 0 auto;
	padding: 0 0 40px;
	max-width: var(--max-content-width);
}
.AddPayoutFailure-textJumbo-iYRBR {
	font-size: 50px;
	font-weight: bold;
	margin: 0;
}
.AddPayoutFailure-textMedium-NcuZh {
	font-size: 30px;
	font-weight: bold;
	margin: 0;
}
.AddPayoutFailure-listStyled-YJyIJ {
	padding-left: 0;
	list-style: none;
}
.AddPayoutFailure-subTitle-Ke360 {
	font-size: 15px;
	color: var(--common-text-color);
}
.AddPayoutFailure-firstBtn-Zt3Xa,
.AddPayoutFailure-firstBtn-Zt3Xa:focus,
.AddPayoutFailure-firstBtn-Zt3Xa:hover,
.AddPayoutFailure-firstBtn-Zt3Xa:active {
	margin-right: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/common.css","webpack://./src/routes/addPayoutFailure/AddPayoutFailure.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;ACRA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzLA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,gCAAgC;CAChC,WAAW;CACX,qBAAqB;CACrB,kDAAkD;CAClD,6BAA6B;CAC7B,8CAA8C;CAC9C,0CAA0C;CAC1C,gBAAgB;AACjB;AAEA;CACC,qDAAqD;CACrD,qBAAqB;CACrB,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;CACC,qGAA6F;SAA7F,6FAA6F;AAC9F;AAEA;;CAEC,8CAA8C;CAC9C,kDAAkD;CAClD,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;CACC,oDAAoD;CACpD,wDAAwD;CACxD,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;;CAEC,8CAA8C;CAC9C,0CAA0C;CAC1C,qDAAqD;CACrD,kBAAkB;CAClB,gCAAgC;CAChC,gBAAgB;CAChB,sCAA8B;SAA9B,8BAA8B;AAC/B;AAEA;CACC,8CAA8C;CAC9C,0CAA0C;CAC1C,qDAAqD;CACrD,gCAAgC;CAChC,gBAAgB;AACjB;AAEA;;CAEC,kDAAkD;CAClD,oDAAoD;CACpD,mCAAmC;CACnC,gCAAgC;CAChC,gBAAgB;CAChB,qBAAqB;AACtB;AAEA;CACC,kDAAkD;CAClD,0DAA0D;CAC1D,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,sBAAsB;CACtB,qBAAqB;CACrB,8CAA8C;CAC9C,0CAA0C;CAC1C,gBAAgB;CAChB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,8CAA8C;CAC9C,0CAA0C;CAC1C,qBAAqB;CACrB,0BAA0B;CAC1B,gBAAgB;CAChB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,sBAAsB;AACvB;AAEA;;CAEC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;AACjB;AAEA;CACC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;AACjB;AAEA;;CAEC,oDAAoD;CACpD,0CAA0C;CAC1C,eAAe;CACf,gBAAgB;CAChB,4DAA4D;CAC5D,2BAA2B;CAC3B,qBAAqB;AACtB;AAEA;CACC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;CAChB,gCAAgC;CAChC,4DAA4D;AAC7D;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,mBAAmB;CACnB,mCAAmC;CACnC,wBAAqB;IAArB,qBAAqB;CACrB,yCAAiC;SAAjC,iCAAiC;CACjC,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,SAAS;CACT,WAAW;CACX,UAAU;CACV,eAAe;CACf,wBAAgB;SAAhB,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CACV,mCAAmC;CACnC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,wBAAqB;IAArB,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,aAAa;CACb,WAAW;CACX,SAAS;CACT,UAAU;CACV,qCAAqC;CACrC,OAAO;CACP,QAAQ;CACR,SAAS;AACV;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,aAAa;AACd;AAEA;CACC,eAAe;CACf,6BAA6B;AAC9B;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,cAAc;CACd,WAAW;CACX,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,wBAAwB;AACzB;AAEA;CACC,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,wBAAwB;AACzB;AAEA;CACC,wCAAwC;CACxC,wCAAwC;CACxC,mCAA2B;SAA3B,2BAA2B;CAC3B,8BAA8B;CAC9B,6CAA6C;CAC7C,qDAAqD;CACrD,mCAAmC;AACpC;AAGA;CACC,kBAAkB;AACnB;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,wBAAgB;UAAhB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,iCAAiC;CAClC;;CAEA;EACC,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;CAClC;;CAEA;EACC,eAAe;EACf,MAAM;EACN,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mCAAmC;CACpC;;CAEA;EACC,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,YAAY;CACb;AACD;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,6BAA6B;AAC9B;AAEA;CACC,oBAAoB;AACrB;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC;EACC,YAAY;CACb;AACD;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,mBAAe;KAAf,eAAe;AAChB;AAEA;;CAEC;EACC,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;CAC/B;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,yBAAyB;CAC1B;AACD;AAEA,qEAAqE;AAErE;CACC,iBAAiB;AAClB;AAEA;;;;CAIC,2DAA2D;CAC3D,mCAAmC;CACnC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,eAAe;AAChB;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,6BAA6B;CAC9B;AACD;AAEA;CACC;EACC,6BAA6B;EAC7B,YAAY;CACb;AACD;AAEA,qEAAqE;AACrE,sEAAsE;AACtE;CACC,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,uCAAuC;CACvC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;AAEA;;;CAGC,gDAAgD;CAChD,wBAAwB;CACxB,kBAAkB;AACnB;AAEA;CACC,gDAAgD;CAChD,wBAAwB;CACxB,uCAAuC;CACvC,kBAAkB;AACnB;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;AAEA;CACC;EACC,qCAAqC;CACtC;AACD;AAEA,oEAAoE;ACpdpE;CACC,kBAAkB;CAClB,mBAAmB;AACpB;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,mCAAmC;AACpC;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,+BAA+B;AAChC;AAEA;;;;CAIC,6BAA6B;AAC9B","sourcesContent":[".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import 'utils.css';\n@import 'helpers.css';\n\n.btn,\n.btn:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 8px 12px 8px !important;\n\twidth: auto;\n\toutline: 0 !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 6px !important;\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btn:hover {\n\tbackground: var(--common-background-color) !important;\n\toutline: 0 !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btn:hover img {\n\tfilter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);\n}\n\n.btnPrimary,\n.btnPrimary:focus {\n\tborder-color: var(--btn-primary-bg) !important;\n\tbackground-color: var(--btn-primary-bg) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnPrimary:hover {\n\tborder-color: var(--btn-primary-bg-hover) !important;\n\tbackground-color: var(--btn-primary-bg-hover) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnPrimaryBorder,\n.btnPrimaryBorder:focus {\n\tborder-color: var(--primary-border) !important;\n\tcolor: var(--common-text-color) !important;\n\tbackground-color: var(--btn-primary-color) !important;\n\tborder-radius: 6px;\n\tpadding: 8px 12px 8px !important;\n\tfont-weight: 500;\n\tbox-shadow: inherit !important;\n}\n\n.btnPrimaryBorder:hover {\n\tborder-color: var(--primary-border) !important;\n\tcolor: var(--common-text-color) !important;\n\tbackground-color: var(--btn-primary-color) !important;\n\ttext-decoration: none !important;\n\tfont-weight: 500;\n}\n\n.btnSecondary,\n.btnSecondary:focus {\n\tborder: 1px solid var(--primary-border) !important;\n\tbackground-color: var(--btn-secondary-bg) !important;\n\tcolor: var(--white-text) !important;\n\tpadding: 8px 12px 8px !important;\n\tfont-weight: 500;\n\twhite-space: pre-line;\n}\n\n.btnSecondary:hover {\n\tborder: 1px solid var(--primary-border) !important;\n\tbackground-color: var(--btn-secondary-hover-bg) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnLink,\n.btnLink:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: inherit;\n\tborder: 0px !important;\n}\n\n.btnLink:hover {\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\toutline: 0 !important;\n\ttext-decoration: underline;\n\tfont-weight: 500;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tborder: 0px !important;\n}\n\n.btnLinkPrimary,\n.btnLinkPrimary:focus {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btnLinkPrimary:hover {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btnLinkSecondary,\n.btnLinkSecondary:focus {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-link-color) !important;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n\tborder-radius: 0 !important;\n\tpadding: 0 !important;\n}\n\n.btnLinkSecondary:hover {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-link-color) !important;\n\tfont-weight: 500;\n\ttext-decoration: none !important;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n}\n\n.searchFilterPopover {\n\tposition: absolute;\n\ttop: 57px;\n\tleft: 0px;\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tdisplay: inline-block;\n\tvisibility: visible;\n\tbackground: var(--primary-white-bg);\n\tborder-image: initial;\n\tbox-shadow: 0px 3px 6px #00000029;\n\tborder-radius: 12px;\n}\n\n.searchFilterPopoverFull {\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: 0px;\n\twidth: 66%;\n\theight: initial;\n\tbox-shadow: none;\n\tvisibility: visible;\n\ttop: 148px;\n\tbackground: var(--primary-white-bg);\n\tborder-radius: 4px;\n\tborder-width: initial;\n\tborder-style: none;\n\tborder-color: initial;\n\tborder-image: initial;\n}\n\n.searchFilterPopoverOverlay {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100%;\n\ttop: 64px;\n\tz-index: 2;\n\tbackground: rgba(255, 255, 255, 0.85);\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n}\n\n.searchFilterPopoverContent {\n\tmin-width: 370px;\n\tpadding: 26px 26px 16px;\n\theight: 294px;\n}\n\n.searchFilterCloseIcon {\n\tfont-size: 30px;\n\tcolor: var(--modalText-color);\n}\n\n.searchFilterPopoverFooter {\n\twidth: 100%;\n\tposition: relative;\n\tline-height: 0;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n\tvertical-align: middle;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\tvertical-align: middle;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\twhite-space: normal;\n}\n\n.fullWidth {\n\twidth: 100% !important;\n}\n\n.captionTitle {\n\tfont-size: 18px;\n}\n\n.showTabletSection {\n\tdisplay: none !important;\n}\n\n.incrementDecrementButton {\n\twidth: 100%;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n\tdisplay: block;\n\toverflow: hidden;\n\t-webkit-appearance: none;\n}\n\n.commonBorder {\n\tborder: 1px solid transparent !important;\n\tcolor: var(--modalText-color) !important;\n\tbox-shadow: none !important;\n\tborder-radius: 60px !important;\n\tbox-shadow: 0 1px 15px 3px #eeebeb !important;\n\t-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;\n\t-webkit-appearance: none !important;\n}\n\n\n.textCenter {\n\ttext-align: center;\n}\n\n@media screen and (max-width: 768px) {\n\t.searchFilterPopoverFull {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0px;\n\t\tbox-shadow: none;\n\t\tborder: 1px solid var(--primary-white-bg);\n\t\tmax-height: 100%;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.searchFilterPopoverContent {\n\t\tmin-width: 320px;\n\t\tpadding: 15px 15px 70px !important;\n\t\theight: 100%;\n\t\tmin-height: 50vh;\n\t\toverflow: hidden;\n\t\toverflow-y: auto;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.searchFilterPopoverHeader {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tz-index: 7;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: 100%;\n\t\tpadding: 10px 15px;\n\t\tbackground: var(--primary-white-bg);\n\t}\n\n\t.searchFilterPopoverFooter {\n\t\tfont-weight: 600;\n\t\tposition: fixed;\n\t\ttop: 38%;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbackground-color: transparent;\n\t\tz-index: 10;\n\t}\n\n\t.textSize {\n\t\tfont-size: 20px;\n\t\tfont-weight: 600;\n\t\tdisplay: block;\n\t\twidth: 100% !important;\n\t\theight: 45px;\n\t}\n}\n\n.capitalizeText {\n\ttext-transform: capitalize;\n}\n\n.hideBothTabletAndMobile {\n\tdisplay: inline-block;\n}\n\n@media (max-width: 1199px) {\n\t.hideBothTabletAndMobile {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width: 350px) {\n\t.btnFontsize {\n\t\tfont-size: 12px !important;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.searchFilterCloseIcon {\n\t\tfont-size: 25px;\n\t}\n}\n\n.transmissionBottom {\n\tpadding-bottom: 21px !important;\n}\n\n.marginTop20 {\n\tmargin-top: 35px;\n}\n\n.marginRight15 {\n\tmargin-right: 15px !important;\n}\n\n.marginNone {\n\tmargin: 0 !important;\n}\n\n.paddingNone {\n\tpadding: 0 !important;\n}\n\n.infoPadding {\n\tpadding-right: 6px;\n}\n\n@media(min-width:768px) {\n\t.pullRight {\n\t\tfloat: right;\n\t}\n}\n\n.displayFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: wrap;\n}\n\n@media(max-width:767px) {\n\n\t.displayFlex {\n\t\tjustify-content: space-between;\n\t}\n\n\t.hideTabletSection {\n\t\tdisplay: none !important;\n\t}\n\n\t.showTabletSection {\n\t\tdisplay: block !important;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n\n.applyBtnDesktop {\n\ttext-align: right;\n}\n\n.applyBtn,\n.applyBtn:hover,\n.applyBtn:active,\n.applyBtn:focus {\n\tbackground-color: var(--common-background-color) !important;\n\tcolor: var(--white-text) !important;\n\tborder-radius: 6px;\n\ttext-decoration: none;\n\tpadding: 9px 15px 10px;\n\tfont-size: 16px;\n}\n\n@media screen and (max-width: 991px) {\n\t.applyBtnDesktop {\n\t\ttext-align: center;\n\t}\n\n\t.applyBtnDesktopRight {\n\t\ttext-align: right !important;\n\t}\n\n\t.applyBtnDesktopNoPaddingRight {\n\t\tpadding-right: 0px !important;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverFooter {\n\t\tposition: relative !important;\n\t\ttop: inherit;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n/*************************** Header Modal Start **********************/\n.activeItem {\n\tpadding: 15px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tborder-radius: 6px;\n\tcursor: pointer;\n\tborder: 1px solid var(--primary-border);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.activeItem:hover,\n.activeItem:focus,\n.activeItem:active {\n\tbackground-color: var(--common-background-color);\n\tcolor: var(--white-text);\n\tborder-radius: 6px;\n}\n\n.activeSection:first-child {\n\tbackground-color: var(--common-background-color);\n\tcolor: var(--white-text);\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.currencyAndLangGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(5, 1fr);\n\tgap: 12px;\n}\n\n@media (max-width:767px) {\n\t.currencyAndLangGrid {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n/*************************** Header Modal End **********************/","@import '../../components/common.css';\n@import '../../components/helpers.css';\n\n.root {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 0 0 40px;\n\tmax-width: var(--max-content-width);\n}\n\n.textJumbo {\n\tfont-size: 50px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.textMedium {\n\tfont-size: 30px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.listStyled {\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.subTitle {\n\tfont-size: 15px;\n\tcolor: var(--common-text-color);\n}\n\n.firstBtn,\n.firstBtn:focus,\n.firstBtn:hover,\n.firstBtn:active {\n\tmargin-right: 10px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `AddPayoutFailure-errorMessage-boTMb`,
	"space1": `AddPayoutFailure-space1-n81Df`,
	"space2": `AddPayoutFailure-space2-Q9vXy`,
	"space3": `AddPayoutFailure-space3-RoklX`,
	"space4": `AddPayoutFailure-space4-KcPE0`,
	"space5": `AddPayoutFailure-space5-CMipt`,
	"space6": `AddPayoutFailure-space6-Ya41c`,
	"space7": `AddPayoutFailure-space7-e84ab`,
	"space8": `AddPayoutFailure-space8-NgcyQ`,
	"spaceTop1": `AddPayoutFailure-spaceTop1-RvsW9`,
	"spaceTop2": `AddPayoutFailure-spaceTop2-Y_Zt9`,
	"spaceTop3": `AddPayoutFailure-spaceTop3-NAjXe`,
	"spaceTop4": `AddPayoutFailure-spaceTop4-JLFdl`,
	"spaceTop5": `AddPayoutFailure-spaceTop5-QFdXG`,
	"spaceTop6": `AddPayoutFailure-spaceTop6-y2CWj`,
	"spaceTop7": `AddPayoutFailure-spaceTop7-_Zk8i`,
	"spaceTop8": `AddPayoutFailure-spaceTop8-erzgE`,
	"noMargin": `AddPayoutFailure-noMargin-sk_0w`,
	"padding1": `AddPayoutFailure-padding1-rqKVt`,
	"padding2": `AddPayoutFailure-padding2-uCPVk`,
	"padding3": `AddPayoutFailure-padding3-gxXM7`,
	"padding4": `AddPayoutFailure-padding4-vJXD7`,
	"padding5": `AddPayoutFailure-padding5-ad0kO`,
	"padding6": `AddPayoutFailure-padding6-SRYGZ`,
	"padding7": `AddPayoutFailure-padding7-GHpAC`,
	"paddingTop1": `AddPayoutFailure-paddingTop1-C6oeT`,
	"paddingTop2": `AddPayoutFailure-paddingTop2-bFwHd`,
	"paddingTop3": `AddPayoutFailure-paddingTop3-WeHk7`,
	"paddingTop4": `AddPayoutFailure-paddingTop4-RiV9_`,
	"paddingTop5": `AddPayoutFailure-paddingTop5-htvDS`,
	"paddingTop6": `AddPayoutFailure-paddingTop6-B9tUz`,
	"paddingTop7": `AddPayoutFailure-paddingTop7-cQo0W`,
	"noPadding": `AddPayoutFailure-noPadding-R8EgF`,
	"spaceMarginBottom0": `AddPayoutFailure-spaceMarginBottom0-BfdTq`,
	"textBold": `AddPayoutFailure-textBold-RR6hf`,
	"textBolder": `AddPayoutFailure-textBolder-e3Uuf`,
	"textNormal": `AddPayoutFailure-textNormal-uuWpt`,
	"textDarkBlue": `AddPayoutFailure-textDarkBlue-tfz9T`,
	"textLightBlue": `AddPayoutFailure-textLightBlue-w00Jg`,
	"textLightSandleGreen": `AddPayoutFailure-textLightSandleGreen-XQtcA`,
	"textLightBrown": `AddPayoutFailure-textLightBrown-nJa8V`,
	"textMediumMaroon": `AddPayoutFailure-textMediumMaroon-zAMkJ`,
	"textBrown": `AddPayoutFailure-textBrown-sKYhg`,
	"textMaroon": `AddPayoutFailure-textMaroon-EfGk7`,
	"textDarkBrown": `AddPayoutFailure-textDarkBrown-YvZC9`,
	"textMediumBrown": `AddPayoutFailure-textMediumBrown-Aygy8`,
	"textSkyBlue": `AddPayoutFailure-textSkyBlue-rPj98`,
	"textGray": `AddPayoutFailure-textGray-wkXWv`,
	"btn": `AddPayoutFailure-btn-glATD`,
	"btnPrimary": `AddPayoutFailure-btnPrimary-lX8Qi`,
	"btnPrimaryBorder": `AddPayoutFailure-btnPrimaryBorder-I_lnL`,
	"btnSecondary": `AddPayoutFailure-btnSecondary-ObVUi`,
	"btnLink": `AddPayoutFailure-btnLink-Ub3IS`,
	"btnLinkPrimary": `AddPayoutFailure-btnLinkPrimary-sJdBB`,
	"btnLinkSecondary": `AddPayoutFailure-btnLinkSecondary-KgeS5`,
	"searchFilterPopover": `AddPayoutFailure-searchFilterPopover-ZmddX`,
	"searchFilterPopoverFull": `AddPayoutFailure-searchFilterPopoverFull-Z36Uw`,
	"searchFilterPopoverOverlay": `AddPayoutFailure-searchFilterPopoverOverlay-Ygd0L`,
	"searchFilterPopoverContent": `AddPayoutFailure-searchFilterPopoverContent-RuB9M`,
	"searchFilterCloseIcon": `AddPayoutFailure-searchFilterCloseIcon-fV_S9`,
	"searchFilterPopoverFooter": `AddPayoutFailure-searchFilterPopoverFooter-YUHkr`,
	"displayTable": `AddPayoutFailure-displayTable-t4CuL`,
	"displayTableRow": `AddPayoutFailure-displayTableRow-uxask`,
	"displayTableCell": `AddPayoutFailure-displayTableCell-Sg56E`,
	"displayInlineBlock": `AddPayoutFailure-displayInlineBlock-xe1Jb`,
	"fullWidth": `AddPayoutFailure-fullWidth-j6jlP`,
	"captionTitle": `AddPayoutFailure-captionTitle-qGe8I`,
	"showTabletSection": `AddPayoutFailure-showTabletSection-fvgVg`,
	"incrementDecrementButton": `AddPayoutFailure-incrementDecrementButton-zXk4H`,
	"commonBorder": `AddPayoutFailure-commonBorder-fAAEm`,
	"textCenter": `AddPayoutFailure-textCenter-kjoB8`,
	"searchFilterPopoverHeader": `AddPayoutFailure-searchFilterPopoverHeader-UGAFB`,
	"textSize": `AddPayoutFailure-textSize-p870C`,
	"capitalizeText": `AddPayoutFailure-capitalizeText-inrZP`,
	"hideBothTabletAndMobile": `AddPayoutFailure-hideBothTabletAndMobile-zaTTK`,
	"btnFontsize": `AddPayoutFailure-btnFontsize-W2C7b`,
	"transmissionBottom": `AddPayoutFailure-transmissionBottom-hrgA8`,
	"marginTop20": `AddPayoutFailure-marginTop20-Pkaxt`,
	"marginRight15": `AddPayoutFailure-marginRight15-EB34w`,
	"marginNone": `AddPayoutFailure-marginNone-IFmk7`,
	"paddingNone": `AddPayoutFailure-paddingNone-fx5M5`,
	"infoPadding": `AddPayoutFailure-infoPadding-WUeAi`,
	"pullRight": `AddPayoutFailure-pullRight-tC2na`,
	"displayFlex": `AddPayoutFailure-displayFlex-HxcCw`,
	"hideTabletSection": `AddPayoutFailure-hideTabletSection-BrlMP`,
	"applyBtnDesktop": `AddPayoutFailure-applyBtnDesktop-xG3hS`,
	"applyBtn": `AddPayoutFailure-applyBtn-h4xI3`,
	"applyBtnDesktopRight": `AddPayoutFailure-applyBtnDesktopRight-Ig3r6`,
	"applyBtnDesktopNoPaddingRight": `AddPayoutFailure-applyBtnDesktopNoPaddingRight-xbjnx`,
	"activeItem": `AddPayoutFailure-activeItem-Gyy0j`,
	"activeSection": `AddPayoutFailure-activeSection-SuNqy`,
	"currencyAndLangGrid": `AddPayoutFailure-currencyAndLangGrid-C5Ybi`,
	"root": `AddPayoutFailure-root-XnqK7`,
	"container": `AddPayoutFailure-container-JWSVr`,
	"textJumbo": `AddPayoutFailure-textJumbo-iYRBR`,
	"textMedium": `AddPayoutFailure-textMedium-NcuZh`,
	"listStyled": `AddPayoutFailure-listStyled-YJyIJ`,
	"subTitle": `AddPayoutFailure-subTitle-Ke360`,
	"firstBtn": `AddPayoutFailure-firstBtn-Zt3Xa`
};
module.exports = ___CSS_LOADER_EXPORT___;
